import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { HemaHeadingWithSubText, HemaLabel, Button, Alert } from '../../utils';
import {
  CrossIcon,
  EyeIcon,
  HideEye,
  NameInformation,
} from '../../HemeIconLibrary';
import { showErrorReducer } from '../../Store/reducers/uiSettings';
import { verifyAllQuestionsForResetPasswordAction } from '../../Actions/auth';
import LoginInput from '../../utils/FormElements/loginInput';

const Index = ({
  allQuestion,
  token,
  setVerifyLink,
  setAllAnsweredQuestions,
}) => {
  const dispatch = useDispatch();
  const [intialValuesFromProp, setIntialValuesFromProp] = useState();
  const [showPassword, setshowPassword] = useState([]);

  useEffect(() => {
    const initialValues = allQuestion?.map((value) => {
      return {
        [value.id]: '',
      };
    });
    setIntialValuesFromProp(
      initialValues?.reduce((obj, item) => Object.assign(obj, item), {})
    );
    let populateArray = [];
    for (var i = 0; i < allQuestion?.length; i++) {
      populateArray.push(false);
    }
    setshowPassword(populateArray);
  }, [JSON.stringify(allQuestion)]);

  return (
    <div className="max-w-[450px]">
      <HemaHeadingWithSubText
        heading="Reset Password"
        sub="Please answer the following security questions to reset your
        password."
        subTextColor="#595959"
      />
      <Formik
        initialValues={intialValuesFromProp}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          allQuestion?.forEach((fields) => {
            if (
              values?.[fields.id] === '' ||
              values?.[fields.id] === null ||
              values?.[fields.id] === undefined
            ) {
              errors[fields.id] = 'Required';
            }
          });
          dispatch(showErrorReducer(''));
          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);
          const allanswers = Object.keys(values).map((question) => {
            return {
              questionId: question,
              answer: values[question],
            };
          });
          setAllAnsweredQuestions(allanswers);
          const questionVerify = await verifyAllQuestionsForResetPasswordAction(
            {
              passwordResetToken: token,
              questions: allanswers,
            }
          );
          setSubmitting(false);
          if (questionVerify.status === 200) {
            setVerifyLink('set-pass');
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
          /* and other goodies */
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="mt-[24px]">
                <Alert type="error" />
              </div>
              {allQuestion?.map((data, counter) => {
                return (
                  <div className="flex flex-col  mb-[24px] mt-[24px]">
                    <HemaLabel
                      text={data.question}
                      Icon={<NameInformation />}
                      textSize="text-[16px]"
                    />
                    <LoginInput
                      type={showPassword?.[counter] ? 'text' : 'password'}
                      name={data.id}
                      placeholder="Enter answer"
                      inputIcon={
                        values?.[data.id] ? (
                          !showPassword?.[counter] ? (
                            <EyeIcon />
                          ) : (
                            <HideEye />
                          )
                        ) : (
                          ''
                        )
                      }
                      crossIcon={values?.[data.id] ? <CrossIcon /> : ' '}
                      value={values?.[data.id]}
                      setshowPassword={(value) => {
                        setshowPassword(
                          showPassword.map((data, counter1) => {
                            if (counter1 === counter) {
                              return value;
                            } else {
                              return data;
                            }
                          })
                        );
                      }}
                      showPassword={showPassword?.[counter]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                    />
                    <p className="error m-0  text-[#F54C3B]">
                      {errors[data.id] && touched[data.id] && errors[data.id]}
                    </p>
                  </div>
                );
              })}

              {isSubmitting ? (
                <Button
                  type="submit"
                  bg="bg-primary1"
                  className="w-full h-[48px] justify-center font-semibold"
                  text={
                    <>
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                      <Spinner animation="grow" size="sm" variant="light" />
                    </>
                  }
                />
              ) : (
                <Button
                  text="Continue"
                  type="submit"
                  bg="bg-primary1"
                  border="border-primary1"
                  color="text-white"
                  className="w-full h-[48px] justify-center font-semibold"
                  disabled={Object.keys(errors)?.length ? true : false}
                />
              )}
            </form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default Index;
